module.exports = __webpack_public_path__ + "img/drgn.883da39d.svg";